import { Column } from './column';

// Example
// +-----+-----------------------+----------------------+
// | DA3 |          DA1          |          DA2         |
// |     |-----------+-----------+-----------+----------+
// |     |    DB1    |    DB2    |    DB1    |    DB2   |
// |     |-----+-----+-----+-----+-----+-----+-----+----+
// |     | M1  | M2  | M1  | M2  | M1  | M2  | M1  | M2 |
// +=====+=====+=====+=====+=====+=====+=====+=====+====+
// |     |     |     |     |     |     |     |     |    |
// +-----+-----+-----+-----+-----+-----+-----+-----+----+

export class TableHeader {

    public headerRows: HeaderRow[] = [];

    constructor(rows: number) {
        for (let i = 0; i < rows; i++) {
            let row = new HeaderRow();
            this.headerRows.push(row);
        }
    }


}

export class HeaderRow {

    public headerElements: HeaderElement[] = [];

}

export class HeaderElement {

    public caption: string;
    public colspan: number;
    public rowspan: number;
    public column: Column;
    public sortIcon?: boolean;

    constructor(caption: string, column: Column, rowspan: number, colspan: number) {
        this.caption = caption;
        this.column = column;
        this.rowspan = rowspan;
        this.colspan = colspan;
    }

}
